export const getInfoFile = (url: string) => {
  const name = url.split("/").pop() ?? "";
  const type = name.split(".").pop() ?? "";
  return {
    uri: url.substring(0, url.lastIndexOf("/")).trim(),
    name,
    type: `application/${type}`,
  };
};
